import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";

export default function Answer(props) {
  const { question, dictionary, answer, click, progress } = props;

  return (
    <div className="own-it__answer">
      <Header current={question.current} all={question.all} />
      <div className="answer__top">
        <div className="answer__top-left">
          <div className="answer__img">
            <img src={answer.data.img} alt="" />
          </div>
          {progress}
        </div>
        <div className="answer__top-right">
          <p className="answer__text">
            {
              dictionary[
                `result_${question.current}_${answer.option +
                  1}_${answer.result + 1}`
              ]
            }
          </p>
          <button
            className="answer__next-btn"
            type="button"
            onClick={() => click()}
          >
            {dictionary.next_btn}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 11">
              <path d="M29 5.5L19 0v4H0v3h19v4z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

Answer.propTypes = {
  dictionary: PropTypes.object,
  answer: PropTypes.object,
  question: PropTypes.object,
  click: PropTypes.func
};
